import React from 'react';
import { useTranslation } from 'react-i18next';
import { SHAPES } from '../../constants/constants';
import { gridUnit } from '../../constants/gridConfig';
import { useStore } from '../../store/store';
import { getColumnAvailableWidth } from '../../utils/columns';
import NavbarSelector from '../Layout/NavbarSelector';
import DuotoneLightIcon from '../common/DuotoneLightIcon';
import LabelledRow from '../common/LabelledRow';
import { getShapeKind, mutateSetShapeKind } from './shapeUtils';

// Sélecteur de nature d'une box « Forme », ligne comprise : il est monté par le
// panneau des formes comme par celui des lignes, pour qu'on puisse passer de
// l'une à l'autre dans les deux sens.
const ShapeKindSelector = ({ box }) => {
  const { t } = useTranslation();
  const updateBox = useStore(({ updateBox }) => updateBox);
  const getBox = useStore(({ getBox }) => getBox);
  const handleSelectBox = useStore(({ handleSelectBox }) => handleSelectBox);
  // Largeur utile de la cellule : une ligne s'étend, elle ne doit pas dépasser
  // de sa colonne. Undefined en mode dessin et sur un masque, où la box est
  // posée librement.
  const columnMaxWidth = useStore((state) => {
    const column = box?.columnId
      ? state.columns.find((c) => c.id === box.columnId)
      : undefined;
    if (!column || column.drawMode) return undefined;
    const width = getColumnAvailableWidth({
      columnId: column.id,
      columns: state.columns,
      containers: state.containers,
      rowContainers: state.rowContainers,
      landscape: state.landscape,
      marginLeft: state.configuration.margins.left * gridUnit,
      marginRight: state.configuration.margins.right * gridUnit,
    });
    return width > 0 ? width : undefined;
  });

  const selectKind = (shapeId) => {
    updateBox(
      box.id,
      (draft) => mutateSetShapeKind(draft, shapeId, { maxWidth: columnMaxWidth }),
      {},
      () => {
        // La box change de type : la sélection est rejouée pour que le panneau
        // de droite se remonte sur le bon composant.
        const updatedBox = getBox(box.id);
        if (updatedBox) handleSelectBox({ box: updatedBox });
      }
    );
  };

  return (
    <LabelledRow label={t('type')}>
      <NavbarSelector
        key='shapeTypeSelector'
        tooltipContent={t('shape')}
        suffixIcon={<DuotoneLightIcon name='vector-polygon' />}
        onSelect={selectKind}
        selectedValue={getShapeKind(box)}
        options={SHAPES.map(({ id, name }) => ({ label: t(name), value: id }))}
      />
    </LabelledRow>
  );
};

export default ShapeKindSelector;
